<template>
  <a-drawer
    :maskClosable="false"
    width="85%"
    :visible="open"
    @close="
      onCloseConfirm(() => {
        open = false
      })
    "
    :destroyOnClose="true"
  >
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>

    <a-form-model
      :model="form"
      ref="form"
      :label-col="{ span: 3 }"
      :rules="rules"
      :wrapper-col="{ span: 10 }"
      class="padding-lr"
    >
      <a-tabs tab-position="top" v-model="tabIndex">
        <!-- 基础信息 -->
        <a-tab-pane :key="1" tab="基础信息">
          <a-row :gutter="12">
            <a-col :span="24">
              <a-form-model-item label="维修分类" prop="categoryId" class="margin-bottom-10">
                <a-select
                  show-search
                  :allowClear="true"
                  v-model="form.categoryId"
                  placeholder="请选择"
                  option-filter-prop="children"
                  :filter-option="filterOption"
                >
                  <a-select-option v-for="d in cateList" :key="d.id">{{ d.categoryName }}</a-select-option>
                </a-select>
              </a-form-model-item>

              <a-form-model-item label="维修品名称" prop="prodName" class="margin-bottom-10">
                <a-input v-model="form.prodName" placeholder="请输入" />
              </a-form-model-item>

              <a-form-model-item label="维修商品简述" prop="brief">
                <a-input v-model="form.brief" type="textarea" placeholder="请输入" :maxLength="500" allow-clear />
              </a-form-model-item>

              <a-form-model-item label="主图" prop="pic">
                <file-upload
                  type="image"
                  :defaultList="form.pic ? [form.pic] : []"
                  @input="getImg($event, 'pic')"
                  :file="form.pic"
                  :count="1"
                  :autoCropHeight="350"
                  :autoCropWidth="350"
                ></file-upload>
              </a-form-model-item>
              <a-form-model-item label="商品图册" prop="img">
                <file-upload
                  type="image"
                  :defaultList="form.img"
                  @input="getImg($event, 'img')"
                  :file="form.img"
                  :count="6"

                ></file-upload>
              </a-form-model-item>

              <div v-if="form.isVideo">
                <a-form-model-item label="视频类型" class="margin-bottom-10" prop="video">
                  <a-radio-group v-model="form.videoType" button-style="solid" @change="changeVideo">
                    <a-radio-button :value="1">本地视频</a-radio-button>
                    <a-radio-button :value="2">视频链接</a-radio-button>
                  </a-radio-group>
                </a-form-model-item>
                <a-row>
                  <a-col :span="2"></a-col>
                  <a-col :span="12">
                    <file-upload
                      v-if="form.videoType === 1"
                      type="video"
                      :defaultList="form.video ? [form.video] : []"
                      @input="getImg($event, 'video')"
                      :count="1"
                      :autoCropHeight="350"
                      :isUpload="false"
                      :autoCropWidth="750"
                    ></file-upload>
                    <div v-if="form.videoType === 2" style="height: 93px; padding-top: 20px">
                      <a-input placeholder="请输入视频链接" v-model="form.video"></a-input>
                    </div>
                  </a-col>
                </a-row>
              </div>

              <a-divider></a-divider>
              <a-row style="margin: 30px 0">
                <a-col :span="2"></a-col>
                <a-col :span="12" class="margin-tb-lg">
                  <a-button type="primary" size="large" @click="changeTab(1, 'next')">下一步</a-button>
                </a-col>
              </a-row>
            </a-col>
          </a-row>
        </a-tab-pane>

        <!-- 规格库存 -->
        <a-tab-pane :key="2" tab="规格库存">
          <div v-show="form.isSpec === 0">
            <a-form-model-item class="margin-bottom-10" label="原价" prop="oriPrice">
              <a-input
                v-model="form.oriPrice"
                oninput="value=value.replace(/[^\d.]/g,'').replace(/^\./g,'').replace(/\.{2,}/g,'.').replace('.','$#$').replace(/\./g,'').replace('$#$','.').replace(/^(\d*\.\d{0,2}).*$/g,'$1')"
                placeholder="请输入"
                suffix="￥"
              />
            </a-form-model-item>
            <a-form-model-item class="margin-bottom-10" label="现价" prop="price">
              <a-input
                v-model="form.price"
                oninput="value=value.replace(/[^\d.]/g,'').replace(/^\./g,'').replace(/\.{2,}/g,'.').replace('.','$#$').replace(/\./g,'').replace('$#$','.').replace(/^(\d*\.\d{0,2}).*$/g,'$1')"
                placeholder="请输入"
                suffix="￥"
              />
            </a-form-model-item>
            <a-form-model-item class="margin-bottom-10" label="排序" prop="sort">
              <a-input v-model="form.sort" placeholder="请输入" oninput="value=value.replace(/[^\d]/g,'')" />
            </a-form-model-item>
          </div>

          <div v-show="form.isSpec === 1">
            <a-button
              type="primary"
              size="small"
              @click="addSkuItem"
              class="margin-left-sm margin-right"
            >添加</a-button
            >

            <a-table
              :loading="loading"
              :rowKey="(record, index) => (record.id ? record.id : index)"
              :columns="skuColumns"
              :data-source="skuList"
              :bordered="true"
            >
              <!-- SKU名称 -->
              <template slot="skuName" slot-scope="text, record, index">
                <a-input
                  v-model="skuList[index].skuName"
                  placeholder="请输入SKU名称"
                  @blur="validateSkuField(index, 'skuName')"
                />
                <div v-if="skuList[index].errors.skuName" class="error-text">{{ skuList[index].errors.skuName }}</div>
              </template>

              <!-- 图片 -->
              <template slot="pic" slot-scope="text, record, index">
                <file-upload
                  type="image"
                  :count="1"
                  :defaultList="skuList[index].pic ? [skuList[index].pic] : []"
                  @input="(url) => handleSkuImageChange(url, index)"
                  :showVal="false"
                  :isUpload="false"
                  :file="skuList[index].pic"
                />
                <div v-if="skuList[index].errors.pic" class="error-text">{{ skuList[index].errors.pic }}</div>
              </template>

              <!-- 销售属性 -->
              <template slot="properties" slot-scope="text, record, index">
                <a-input
                  v-model="skuList[index].properties"
                  placeholder="请输入销售属性"
                  @blur="validateSkuField(index, 'properties')"
                />
                <div v-if="skuList[index].errors.properties" class="error-text">
                  {{ skuList[index].errors.properties }}
                </div>
              </template>

              <!-- 是否上门服务 -->
              <template slot="isServiceFee" slot-scope="text, record, index">
                <a-switch
                  :checked="skuList[index].isServiceFee"
                  @change="(val) => (skuList[index].isServiceFee = val)"
                />
              </template>

              <!-- 原价 -->
              <template slot="oriPrice" slot-scope="text, record, index">
                <a-input-number
                  v-model="skuList[index].oriPrice"
                  :min="0"
                  :precision="2"
                  style="width: 100%"
                  @blur="validateSkuField(index, 'oriPrice')"
                  placeholder="原价"
                />
                <div v-if="skuList[index].errors.oriPrice" class="error-text">{{ skuList[index].errors.oriPrice }}</div>
              </template>

              <!-- 现价 -->
              <template slot="price" slot-scope="text, record, index">
                <a-input-number
                  v-model="skuList[index].price"
                  :min="0"
                  :precision="2"
                  style="width: 100%"
                  @blur="validateSkuField(index, 'price')"
                  placeholder="现价"
                />
                <div v-if="skuList[index].errors.price" class="error-text">{{ skuList[index].errors.price }}</div>
              </template>

              <!-- 最大维修价 -->
              <template slot="maxPrice" slot-scope="text, record, index">
                <a-input-number
                  v-model="skuList[index].maxPrice"
                  :min="0"
                  :precision="2"
                  style="width: 100%"
                  @blur="validateSkuField(index, 'maxPrice')"
                  placeholder="最大维修价"
                />
                <div v-if="skuList[index].errors.maxPrice" class="error-text">{{ skuList[index].errors.maxPrice }}</div>
              </template>

              <!-- 参考价 -->
              <template slot="referencePrice" slot-scope="text, record, index">
                <a-input
                  v-model="skuList[index].referencePrice"
                  placeholder="请输入参考价"
                  @blur="validateSkuField(index, 'referencePrice')"
                />
                <div v-if="skuList[index].errors.referencePrice" class="error-text">
                  {{ skuList[index].errors.referencePrice }}
                </div>
              </template>

              <!-- 详细描述 -->
              <template slot="content" slot-scope="text, record, index">
                <a-button type="link" @click="openContentEditor(index)">编辑详情</a-button>
              </template>

              <!-- 备注 -->
              <template slot="remark" slot-scope="text, record, index">
                <a-input
                  v-model="skuList[index].remark"
                  placeholder="请输入备注"
                  style="width: 100%"
                  @blur="validateSkuField(index, 'remark')"
                />
                <div v-if="skuList[index].errors.remark" class="error-text">{{ skuList[index].errors.remark }}</div>
              </template>

              <!-- 排序 -->
              <template slot="sort" slot-scope="text, record, index">
                <a-input-number
                  v-model="skuList[index].sort"
                  :min="0"
                  style="width: 100%"
                  @blur="validateSkuField(index, 'sort')"
                  placeholder="排序"
                />
                <div v-if="skuList[index].errors.sort" class="error-text">{{ skuList[index].errors.sort }}</div>
              </template>

              <!-- 状态 -->
              <template slot="status" slot-scope="text, record, index">
                <a-switch
                  :checked="skuList[index].status === 1"
                  @change="(val) => (skuList[index].status = val ? 1 : 0)"
                />
              </template>

              <!-- 操作 -->
              <template slot="action" slot-scope="text, record, index">
                <a-button type="link" danger @click="removeSkuItem(index)" :disabled="skuList.length <= 1">
                  删除
                </a-button>
              </template>
            </a-table>
          </div>

          <a-divider></a-divider>
          <a-row style="margin: 30px 0">
            <a-col :span="2"></a-col>
            <a-col :span="12" class="margin-tb-lg">
              <a-button @click="changeTab(2, 'back')" size="large" class="margin-right">上一步</a-button>
              <a-button @click="submitForm" type="primary" size="large">保存</a-button>
            </a-col>
          </a-row>

          <a-divider></a-divider>
        </a-tab-pane>

        <!-- 其他设置 -->
        <!-- <a-tab-pane :key="3" tab="其他设置">
          <a-form-model-item label="商品详情" prop="content" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }">
            <editor v-model="form.content" />
          </a-form-model-item>
          <a-divider></a-divider>
          <a-row style="margin: 30px 0">
            <a-col :span="2"></a-col>
            <a-col :span="12" class="margin-tb-lg">
              <a-button @click="submitForm" type="primary" size="large">保存</a-button>
            </a-col>
          </a-row>
        </a-tab-pane> -->
      </a-tabs>
    </a-form-model>
    <sku-content-editor ref="contentEditor" @confirm="saveContentEditor" />
  </a-drawer>
</template>

<script>
import { getObj, addObj, putObj } from '@/api/repairModule/repairProducts'
import editor from '@/components/Editor/Editor.vue'
import SkuContentEditor from '../SkuContentEditor/index'
export default {
  name: 'CreateForm',
  props: {
    cateList: {
      type: Array,
      required: true,
    },
  },
  components: { editor, SkuContentEditor },

  data() {
    return {
      currentIndex: null, // 当前编辑的 sku 下标
      loading: false,
      submitLoading: false,
      tabIndex: 1,
      formTitle: '',
      open: false,
      visibleTabKeys: [1, 2],
      form: {
        id: undefined,
        categoryId: undefined,
        content: undefined,
        img: [],
        oriPrice: undefined,
        pic: undefined,
        prodName: undefined,
        prodType: 0,
        remark: undefined,
        scorePrice: 0,
        sort: 99,
        totalStocks: undefined,
        video: undefined,
        isSpec: 1,
        brief: undefined,
        goldBeansPrice: 0,
        isRecommend: true,
        videoType: 1,
        isVideo: false,
      },

      skuList: [],

      rules: {
        sort: [{ required: true, message: '请输入排序', trigger: 'blur' }],
        prodName: [{ required: true, message: '请输入维修品名称', trigger: 'blur' }],
        categoryId: [{ required: true, message: '请选择商品分类', trigger: 'blur' }],
        brief: [{ required: true, message: '请输入商品简介', trigger: 'blur' }],
        // content: [{ required: true, message: '请输入商品详情', trigger: 'blur' }],
        // oriPrice: [{ required: true, message: '请输入原价', trigger: 'blur' }],
        // price: [{ required: true, message: '请输入现价', trigger: 'blur' }],
      },
    }
  },

  computed: {
    skuColumns() {
      return [
        {
          title: 'SKU名称',
          dataIndex: 'skuName',
          align: 'center',
          scopedSlots: { customRender: 'skuName' },
          width: 180,
        },
        { title: '图片', dataIndex: 'pic', align: 'center', scopedSlots: { customRender: 'pic' } },
        // {
        //   title: '销售属性',
        //   dataIndex: 'properties',
        //   align: 'center',
        //   scopedSlots: { customRender: 'properties' },
        // },
        {
          title: '是否上门',
          dataIndex: 'isServiceFee',
          align: 'center',
          scopedSlots: { customRender: 'isServiceFee' },

        },
        {
          title: '原价',
          dataIndex: 'oriPrice',
          align: 'center',
          scopedSlots: { customRender: 'oriPrice' },

        },
        {
          title: '现价',
          dataIndex: 'price',
          align: 'center',
          scopedSlots: { customRender: 'price' },

        },
        {
          title: '最大维修价',
          dataIndex: 'maxPrice',
          align: 'center',
          scopedSlots: { customRender: 'maxPrice' },
        },
        {
          title: '参考价',
          dataIndex: 'referencePrice',
          align: 'center',
          scopedSlots: { customRender: 'referencePrice' },
        },
        {
          title: '详细描述',
          dataIndex: 'content',
          align: 'center',
          scopedSlots: { customRender: 'content' },
          width: 120,
        },
        // {
        //   title: '备注',
        //   dataIndex: 'remark',
        //   align: 'center',
        //   scopedSlots: { customRender: 'remark' },
        //   width: 120
        // },
        {
          title: '排序',
          dataIndex: 'sort',
          align: 'center',
          scopedSlots: { customRender: 'sort' },
        },
        {
          title: '状态',
          dataIndex: 'status',
          align: 'center',
          scopedSlots: { customRender: 'status' },
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' },
          fixed: 'right',
          width: 140,
        },
      ]
    },
  },

  methods: {
    /* 打开弹窗 */
    openContentEditor(index) {
      this.currentIndex = index
      const html = this.skuList[index].content || ''
      this.$refs.contentEditor.open(html) // ← 命令式调用
    },

    /* 保存回调 */
    saveContentEditor(html, done) {
      this.skuList[this.currentIndex].content = html
      this.validateSkuField(this.currentIndex, 'content') // 旧校验
      done() // 通知子组件可以关闭了
    },
    onClose() {
      this.open = false
      this.reset()
    },

    getImg(info, fieldName) {
      this.form[fieldName] = info
      this.$refs.form.clearValidate(fieldName)
    },

    handleSkuImageChange(url, index) {
      this.skuList[index].pic = url
      this.$refs.form.clearValidate(`skuList[${index}].pic`)
    },

    changeTab(curKey, type) {
      /* ------- 上一步 ------- */
      if (type === 'back') {
        this.tabIndex = curKey - 1
      }
      /* ------- 下一步 ------- */
      if (curKey === 1) {
        this.$refs.form.validate((valid) => {
          if (!valid) return
          this.tabIndex += 1
        })
      }
    },

    changeVideo(e) {
      this.form.videoType = e.target.value
    },

    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },

    reset() {
      this.form = {
        id: undefined,
        categoryId: undefined,
        content: undefined,
        img: [],
        oriPrice: undefined,
        pic: undefined,
        prodName: undefined,
        prodType: 0,
        remark: undefined,
        scorePrice: 0,
        sort: 99,
        totalStocks: undefined,
        video: undefined,
        isSpec: 1,
        brief: undefined,
        goldBeansPrice: 0,
        isRecommend: true,
        videoType: 1,
        isVideo: false,
      }
      this.skuList = []
      this.tabIndex = 1
    },

    // 创建SKU项时初始化所有字段和错误信息
    createSkuItem() {
      return {
        id: undefined,
        skuName: '',
        properties: '',
        pic: '',
        oriPrice: 0,
        price: 0,
        maxPrice: 0,
        referencePrice: '',
        content: '',
        remark: '',
        sort: 0,
        status: 1,
        isServiceFee: false,
        errors: {
          skuName: '',
          // properties: '',
          pic: '',
          oriPrice: '',
          price: '',
          maxPrice: '',
          referencePrice: '',
          content: '',
          remark: '',
          sort: '',
        },
      }
    },

    addSkuItem() {
      this.skuList.push(this.createSkuItem())
    },

    removeSkuItem(index) {
      // 确保索引在有效范围内
      if (index >= 0 && index < this.skuList.length) {
        this.skuList.splice(index, 1)

        // 可选：删除后重新验证剩余的SKU项
        this.validateAllSkuFields()
      } else {
        console.error('无效的SKU索引:', index)
      }
    },

    // 验证单个SKU字段
    validateSkuField(index, field) {
      const item = this.skuList[index]
      item.errors[field] = ''

      let isValid = true
      const value = item[field]

      switch (field) {
        case 'skuName':
          if (!value || value.trim() === '') {
            item.errors.skuName = 'SKU名称不能为空'
            isValid = false
          } else if (value.length > 50) {
            item.errors.skuName = 'SKU名称不能超过50个字符'
            isValid = false
          }
          break

        // case 'properties':
        //   if (!value || value.trim() === '') {
        //     item.errors.properties = '销售属性不能为空'
        //     isValid = false
        //   }
        //   break

        case 'pic':
          if (!value || value.trim() === '') {
            item.errors.pic = 'SKU图片不能为空'
            isValid = false
          }
          break

        case 'oriPrice':
          if (value === null || value === undefined || value === '') {
            item.errors.oriPrice = '原价不能为空'
            isValid = false
          } else if (isNaN(value) || Number(value) < 0) {
            item.errors.oriPrice = '原价必须为大于等于0的数字'
            isValid = false
          }
          break

        case 'price':
          if (value === null || value === undefined || value === '') {
            item.errors.price = '现价不能为空'
            isValid = false
          } else if (isNaN(value) || Number(value) < 0) {
            item.errors.price = '现价必须为大于等于0的数字'
            isValid = false
          } else if (Number(value) > Number(item.oriPrice)) {
            item.errors.price = '现价不能高于原价'
            isValid = false
          }
          break

        case 'maxPrice':
          if (value === null || value === undefined || value === '') {
            item.errors.maxPrice = '最大维修价不能为空'
            isValid = false
          } else if (isNaN(value) || Number(value) < 0) {
            item.errors.maxPrice = '最大维修价必须为大于等于0的数字'
            isValid = false
          }
          break

        case 'referencePrice':
          if (!value || value.trim() === '') {
            item.errors.referencePrice = '参考价不能为空'
            isValid = false
          }
          break

        case 'sort':
          if (value === null || value === undefined || value === '') {
            item.errors.sort = '排序不能为空'
            isValid = false
          } else if (isNaN(value) || Number(value) < 0) {
            item.errors.sort = '排序必须为大于等于0的整数'
            isValid = false
          }
          break
      }

      return isValid
    },

    // 验证所有SKU字段
    validateAllSkuFields() {
      let isValid = true
      const requiredFields = ['skuName', 'pic', 'oriPrice', 'price', 'maxPrice', 'referencePrice', 'sort']

      this.skuList.forEach((item, index) => {
        requiredFields.forEach((field) => {
          if (!this.validateSkuField(index, field)) {
            isValid = false
          }
        })
      })

      return isValid
    },

    handleAdd(e) {
      this.tabIndex = 1
      this.reset()
      this.open = true
      if (e) {
        this.form.categoryId = e
      }
      this.formTitle = '添加维修产品项'
    },

    handleUpdate(row, ids) {
      this.tabIndex = 1
      this.reset()
      const postId = row ? row.id : ids

      getObj(postId).then((response) => {
        const data = response.data
        data.isSpec = data.skus && data.skus.length > 0 ? 1 : 0

        // 修正图片数据格式
        data.img = data.imgs ? JSON.parse(data.imgs) : []

        if (data.skus && data.skus.length > 0) {
          this.skuList = data.skus.map((sku) => ({
            ...sku,
            isServiceFee: sku.isServiceFee || false,
            oriPrice: Number(sku.oriPrice) || 0,
            price: Number(sku.price) || 0,
            maxPrice: Number(sku.maxPrice) || 0,
            sort: Number(sku.sort) || 0,
            status: sku.status || 1,
            errors: {
              skuName: '',
              oriPrice: '',
              price: '',
              sort: '',
            },
          }))
        }

        this.form = data
        this.open = true
        this.formTitle = '修改维修产品项'

        // 强制更新视图
        this.$nextTick(() => {})
      })
    },

    submitForm() {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          this.$message.error('请完善表单信息')
          return
        }

        if (this.form.isSpec === 1) {
          if (this.skuList.length === 0) {
            this.$message.warning('请至少添加一个规格')
            return
          }

          if (!this.validateAllSkuFields()) {
            this.$message.warning('请完善规格信息')
            return
          }
        }

        const submitData = { ...this.form }

        if (this.form.isSpec === 1) {
          submitData.addParams = this.skuList.map((sku) => ({
            id: sku.id || undefined,
            skuName: sku.skuName || '',
            properties: sku.properties || '',
            pic: sku.pic || '',
            oriPrice: Number(sku.oriPrice) || 0,
            price: Number(sku.price) || 0,
            maxPrice: Number(sku.maxPrice) || 0,
            referencePrice: sku.referencePrice || '',
            content: sku.content || '',
            remark: sku.remark || '',
            sort: Number(sku.sort) || 0,
            status: sku.status || 1,
            isServiceFee: Boolean(sku.isServiceFee),
          }))
        } else {
          submitData.skuList = [
            {
              id: undefined,
              skuName: this.form.prodName || '默认SKU',
              // properties: '',
              pic: this.form.pic || '',
              oriPrice: Number(this.form.oriPrice) || 0,
              price: Number(this.form.price) || 0,
              maxPrice: 0,
              referencePrice: '',
              content: '',
              remark: '',
              sort: Number(this.form.sort) || 0,
              status: 1,
              isServiceFee: false,
            },
          ]
        }

        this.submitLoading = true
        const submitMethod = this.form.id !== undefined ? putObj : addObj

        submitMethod(submitData)
          .then((response) => {
            this.$message.success(`${this.form.id !== undefined ? '修改' : '新增'}成功`)
            this.open = false
            this.$emit('ok')
          })
          .catch((error) => {
            this.$message.error('操作失败')
            console.error('提交错误:', error)
          })
          .finally(() => {
            this.submitLoading = false
          })
      })
    },
  },
}
</script>

<style lang="less" scoped>
/deep/.ant-tabs-tab {
  border: none !important;
  padding-top: 0 !important;
}
.ant-tabs-bar {
  border: none !important;
  box-shadow: none !important;
  height: 45px !important;
  padding-top: 5px !important;
}

.cursorhand {
  cursor: pointer;
}
.margin-bottom-10 {
  margin-bottom: 10px;
}
.margin-bottom-sm {
  margin-bottom: 8px;
}
.margin-bottom-xs {
  margin-bottom: 4px;
}
.margin-tb {
  margin: 10px 0;
}
.margin-tb-lg {
  margin: 20px 0;
}
.margin-left-sm {
  margin-left: 8px;
}
.margin-right {
  margin-right: 8px;
}
.padding-lr {
  padding: 0 16px;
}
.flex {
  display: flex;
}
.align-center {
  align-items: center;
}
.box {
  border: 1px solid #d9d9d9;
  padding: 8px;
  border-radius: 4px;
}
.error-text {
  color: #ff4d4f;
  font-size: 12px;
  margin-top: 4px;
}
</style>
